import { render } from "./form-body.vue?vue&type=template&id=7059e7b8"
import script from "./form-body.vue?vue&type=script&lang=js"
export * from "./form-body.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__